/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_TitleInputs */

const he_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עזרה ותמיכה`)
};

const en_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help & Support`)
};

/**
* | output |
* | --- |
* | "Help & Support" |
*
* @param {Help_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const help_title = /** @type {((inputs?: Help_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_title(inputs)
	return en_help_title(inputs)
});